export default function Loader() {
  return (
    <div className="sidebar__body loaderContainer">
      <div className="lds-dual-ring"></div>
    </div>
  );
}
